export default {
  tooltip_title: 'Clic para copiar',
  success: '¡Copiado!',
};
